export default class InputOperation
{
  constructor(id, operation) 
  {
    
    this.id = id;
    this.operation = operation;
  }    
}